<template>
    <div>
        <v-col class="co-modelos">
            <barra-saldo ref="refBarraSaldo" />

            <div class="criar-pesquisar-wrapper d-flex mt-5 mx-5">
                <v-btn class="novo-modelo-btn" color="primary" :loading="carregando" @click="abrirDialogNovoModelo" v-if="!ehMobile">
                    <v-icon left> mdi-plus-circle </v-icon>
                    <span>Criar modelo</span>
                </v-btn>

                <v-btn v-else fab small class="novo-modelo-btn-mobile" color="primary" :loading="carregando" @click="abrirDialogNovoModelo">
                    <v-icon> mdi-plus </v-icon>
                </v-btn>

                <v-spacer v-if="!ehMobile" />

                <campo-pesquisa-modelo @filtrar="filtrarModelos" :filtros="filtros" />
            </div>

            <lista-modelos
                :paginacao="paginacao"
                :modelos="modelos"
                :quantidadesLinhas="quantidadesLinhas"
                @abrir-dialog-renomear="abrirDialogRenomear"
                @abrir-confirmar-deletar="abrirDialogConfirmardeletarModelo"
                @duplicar="duplicarModelo"
                @editar="editarModelo"
                @visualizar="visualizarModelo"
                @mudar-pagina="mudarPagina"
                @mudar-quantidade-por-pagina="mudarQuantidadePorPagina"
            />
        </v-col>

        <dialog-default-confirmar-acao
            v-if="dialogMostrarConfirmacao"
            :dialog="dialogMostrarConfirmacao"
            sentimento="atencao"
            titulo="Eita! Deixa eu confirmar uma coisa..."
            :subtitulo="confirmacao.subtitulo"
            :label-botao-principal="confirmacao.labelBotao"
            :telaCheia="ehMobile"
            @acao-principal="confirmacao.acaoPrincipal()"
            @fechar="fecharDialogMostrarConfirmacao"
        />

        <dialog-novo-modelo
            v-if="dialogNovoModelo.abrir"
            :dialog="dialogNovoModelo"
            :modelo="modelo"
            @fechar="fecharDialogNovoModelo"
            @buscar-modelos="buscarModelos"
        />
    </div>
</template>

<script>
import {actionTypes} from '@/commons/constants'
import BarraSaldo from '@/views/home/meus-contratos/components/BarraSaldo'
import DialogNovoModelo from './components/dialog/DialogNovoModelo'
import DialogDefaultConfirmarAcao from '@/commons/components/dialogs/DialogDefaultConfirmarAcao'
import CampoPesquisaModelo from './components/CampoPesquisaModelo'
import ListaModelos from './components/lista-modelos/ListaModelos'

export default {
    name: 'Modelos',
    components: {
        BarraSaldo,
        DialogNovoModelo,
        CampoPesquisaModelo,
        DialogDefaultConfirmarAcao,
        ListaModelos,
    },
    data() {
        return {
            carregando: false,
            modelo: {
                id: null,
                tituloModelo: '',
                situacao: 'Ativo',
            },
            dialogNovoModelo: {
                abrir: false,
                editando: false,
            },
            confirmacao: {
                subtitulo: '',
                acaoPrincipal: () => {
                    // acao default
                },
                labelBotao: '',
            },
            dialogMostrarConfirmacao: false,
            modelos: [],
            filtros: { titulo: { value: null, default: null } },
            quantidadesLinhas: [5, 10, 15, 25, 50],
            paginacao: { page: 1, rowsPerPage: 10, numPages: 0, sortBy: 'titulo', descending: true },
        }
    },
    computed: {
        ehMobile() {
            return this.$vuetify.breakpoint.xsOnly
        },
    },
    async mounted() {
        this.$store.state.loki.page.title = 'Modelos'
        await this.calcularNumeroLinhas()
        await this.buscarModelos()
    },
    methods: {
        abrirDialogNovoModelo() {
            this.dialogNovoModelo.abrir = true
            this.editando = false
            this.modelo = {
                tituloModelo: '',
                situacao: 'ATIVO',
            }
        },
        abrirVisualizarModelo(modeloId, tipo) {
            if (this.ehMobile) return

            this.$router.push({ name: 'visualizarModelo', params: { id: modeloId, tipo } })
        },
        abrirDialogRenomear(modelo) {
            this.dialogNovoModelo.abrir = true
            this.dialogNovoModelo.editando = true
            this.modelo = {
                id: modelo.id,
                tituloModelo: modelo.titulo,
                situacao: modelo.situacao.toUpperCase(),
            }
        },
        abrirDialogConfirmardeletarModelo(modeloExcluindoId) {
            this.confirmacao = {
                subtitulo: `Deseja realmente excluir esse modelo?</br> Após a exclusão o modelo será eliminado da plataforma e não será mais possível recuperá-lo. Os ${this.$tc(
                    'pt_br.documento',
                    2
                ).toLowerCase()} que foram utilizados por esse modelo continuarão armazenados.`,
                labelBotao: 'Sim, eu quero excluir!',
                acaoPrincipal: this.confirmarExcluirModelo,
            }

            this.dialogMostrarConfirmacao = true
            this.modelo.id = modeloExcluindoId
        },
        async buscarModelos() {
            const data = await this.$store.dispatch(actionTypes.MODELO.BUSCAR_TODOS, {
                filtros: this.filtros,
                paginacao: this.paginacao,
            })

            this.modelos = data.content
            this.paginacao.numPages = data.totalPages
        },
        async confirmarExcluirModelo() {
            await this.$store.dispatch(actionTypes.MODELO.REMOVER, { id: this.modelo.id })
            this.mostrarNotificacaoSucessoDefault()

            await this.buscarModelos()

            this.fecharDialogMostrarConfirmacao()
        },
        async calcularNumeroLinhas() {
            if (!this.ehMobile) {
                let qtdLinhasIdeal = Math.floor((window.innerHeight - 316) / 40)
                this.paginacao.rowsPerPage = qtdLinhasIdeal
                this.quantidadesLinhas.push(qtdLinhasIdeal)
                this.quantidadesLinhas.sort(function (a, b) {
                    return a - b
                })
            }
        },
        async duplicarModelo(modeloId) {
            await this.$store.dispatch(actionTypes.MODELO.DUPLICAR, { id: modeloId })
            this.mostrarNotificacaoSucesso('Modelo duplicado com sucesso!')

            this.paginacao.page = 1
            await this.buscarModelos()
        },
        editarModelo(modeloId) {
            this.abrirVisualizarModelo(modeloId, 'edicao')
        },
        fecharDialogNovoModelo() {
            this.dialogNovoModelo.abrir = false
            this.dialogNovoModelo.editando = false
            this.modelo = {
                id: '',
                tituloModelo: '',
                situacao: '',
            }
        },
        fecharDialogMostrarConfirmacao() {
            this.dialogMostrarConfirmacao = false
            this.modelo.id = null
        },
        async filtrarModelos() {
            this.paginacao.page = 1
            await this.buscarModelos()
        },
        async mudarQuantidadePorPagina() {
            this.paginacao.page = 1
            await this.buscarModelos()
        },
        async mudarPagina() {
            await this.buscarModelos()
        },
        visualizarModelo(modeloId) {
            this.abrirVisualizarModelo(modeloId, 'visualizar')
        },
    },
}
</script>

<style lang="stylus">
.co-modelos
    background-color var(--background-100)
    padding 0px
    height calc(100vh - 96px)
    overflow-y auto
    padding-bottom 20px

    .criar-pesquisar-wrapper
        .novo-modelo-btn-mobile
            position: fixed;
            z-index: 3
            bottom: 20px
            right: 20px
            width 56px
            height 56px

@media (max-width: 720px)
    .co-modelos
        height calc(100vh - 60px) !important
</style>
